import { NameListTab } from "./NameListTab";

export default NameListTab;
